import axios from '../../js/axios-interceptor'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index/IndexView.vue'),
  },
  {
    path: '/SystemBody',
    name: 'systemBody',
    component: () => import('../views/mind/SystemBody.vue'),
  },
  {
    path: '/blog/:type',
    name: 'blog',
    component: () => import('../views/blog/BlogView.vue'),
  },
  {
    path: '/article/:article' + '.html',
    name: 'article',
    component: () => import('../views/blog/BlogArticle.vue')
  },
  {
    path: '/backend',
    name: 'backend',
    meta: {
      requiredRoles: true
    },
    component: () => import('../views/backend/BackIndex.vue'),
    children: [
      {
        path: 'writeBlog',
        name: 'writeBlog',
        component: () => import('../views/backend/blog/WriteBlog.vue'),
      },
      {
        path: 'editBlog',
        name: 'editBlog',
        component: () => import('../views/backend/blog/EditBlog.vue'),
      },
      {
        path: 'manageBlog',
        name: 'manageBlog',
        component: () => import('../views/backend/blog/ManageBlog.vue'),
      },
      {
        path: 'indexPattern',
        name: 'indexPattern',
        component: () => import('../views/backend/pattern/IndexPattern.vue'),
      },
      {
        path: 'routerPattern',
        name: 'routerPattern',
        component: () => import('../views/backend/pattern/RouterPattern.vue'),
      },
      {
        path: 'footerPattern',
        name: 'footerPattern',
        component: () => import('../views/backend/pattern/FooterPattern.vue'),
      }
    ]
  },
  {
    path: '/toUserLogin',
    name: 'toUserLogin',
    component: () => import('../views/user/UserLogin.vue')
  },
  // 通配符路由，匹配所有未被其他路由匹配到的路径
  {
    path: '*',
    name: '404',
    component: () => import('../views/system/404.vue')
  }
]

const router = new VueRouter({
  routes,
  // mode: 'history',
  base: process.env.BASE_URL
})

// 导航守卫
router.beforeEach((to, from, next) => {
  // 检查目标路由是否需要身份验证
  if (to.matched.some(record => record.meta.requiredRoles)) {
    // 检查用户是否已登录，这里假设您有一个名为 isAuthenticated 的状态来表示用户登录状态
    // 检查用户令牌
    const jwt = localStorage.getItem('jwt');
    if (jwt == null || jwt == '') {
      // 如果用户未登录，则重定向到登录页面
      next({});
    }
    axios.get("/login/checkJwt", {
      params: {
        "jwt": jwt
      }
    }).then((res) => {
      if (res.data.code === 1) {
        next();
      } else {
        next({ name: '404' });
      }
    })
  } else {
    // 如果目标路由不需要身份验证，则允许访问
    next();
  }
});

export default router
